import React, { useState, useEffect } from "react";
import Navbar from "../Navbar/Navbar";
import Table from "../Table/Table";
import Table_Buttons from "../Table_Button/Table_button";
import { toast } from "react-toastify";
import { API } from "../../Redux/actions/API";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { updateAuth } from "../../Redux/actions/AdminAuthSlice";
import Spinner from "../Spinner/Spinner";

function AddmodifyPlansDetails() {
  const { userId, jwt_token } = useSelector((state) => state.Auth);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [isLoading, setisLoading] = useState(false);
  const [currentPage, setcurrentPage] = useState(1);
  const [listPerpage, setlistPerpage] = useState(10);
  const [leftreferralApi, setleftreferralApi] = useState([]);

  const [PlanAmount, setPlanAmount] = useState(0);
  const [Gst, setGst] = useState(0);
  const [EV, setEV] = useState(0);
  const [Roi, setRoi] = useState(0);
  const [RoiMonths, setRoiMonths] = useState(0);
  const [ID, setID] = useState(0);

  const referral_API = async () => {
    setisLoading(true);
    try {
      let responceRight = await API?.get(
        `GetPlans?type=Upgrade&loginid=${userId}`,
        {
          headers: {
            Authorization: `${jwt_token}`,
            "Content-Type": "application/json",
          },
        },
      );

      responceRight = responceRight?.data?.data[0];
      setID(responceRight[0]?.id);

      setleftreferralApi([]);
      let arrayLeft = [];
      responceRight.forEach((item, index) => {
        arrayLeft.push({
          sr: index + 1,
          PlanAmount: item.PlanAmount,
          Gst: item.Gst,
          EV: `${item.EV}`,
          Roi: `${item.Roi}`,
          RoiMonths: item.RoiMonths,
          status: item.status === 1 ? "Active" : "Inactive",
        });
        setleftreferralApi(arrayLeft);
      });
    } catch (e) {
      console.log("error Balance APi", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    } finally {
      setisLoading(false);
    }
  };

  const AddnewPlan = async () => {
    setisLoading(true);
    try {
      if (
        PlanAmount === "" ||
        PlanAmount === 0 ||
        Gst === "" ||
        Gst === 0 ||
        EV === "" ||
        EV === 0
      ) {
        toast.error("Enter All Required Fields");
        return;
      }

      let responceRight = await API?.post(
        "/InsertPlans",
        {
          loginid: userId,
          ID: ID,
          type: "Update",
          amount: PlanAmount,
          Gst: Gst,
          EV: EV,
          // Roi: Roi,
          // RoiMonths: RoiMonths,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        },
      );

      console.log("My_Team", responceRight.data);
      if (
        responceRight.data.data.result === "Saved !!" ||
        responceRight.data.data.result === "Updated !!"
      ) {
        toast.success(responceRight.data.data.result);
        setPlanAmount("");
        setEV("");
        setGst("");
        setRoi("");
        setRoiMonths("");
        referral_API();
      } else {
        toast.error(responceRight.data.data.result);
      }
    } catch (e) {
      console.log("error Balance APi", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    } finally {
      setisLoading(false);
    }
  };

  useEffect(() => {
    referral_API();
  }, []);

  const indexOfLastPost = currentPage * listPerpage;
  const indexOfFirstPage = indexOfLastPost - listPerpage;
  const currentPostleft = leftreferralApi.slice(
    indexOfFirstPage,
    indexOfLastPost,
  );

  var [my_team, set_my_team] = new useState({
    cols: [
      { Header: "S.No", accessor: "sr" },
      { Header: "Plan Amount", accessor: "PlanAmount" },
      { Header: "GST", accessor: "Gst" },
      { Header: "EV", accessor: "EV" },
      // { Header: "Roi", accessor: "Roi" },
      // { Header: "Roi Months", accessor: "RoiMonths" },
      // { Header: "Status", accessor: "status" },
    ],
  });

  return (
    <div>
      <Navbar />
      <div class="content-page">
        <div class="content">
          <div class="row">
            <div class="col-md-12">
              <div class="panel panel-primary">
                <div class="panel-heading">
                  <h4 class="panel-title">Add New Plan</h4>
                </div>
                <div class="panel-body">
                  <div class="row">
                    <div class="col-md-3">
                      <label>Plan Amount</label>
                      <input
                        type="number"
                        id="txtuid"
                        value={PlanAmount}
                        onChange={(e) => setPlanAmount(e.target.value)}
                        class="form-control ng-pristine ng-untouched ng-valid ng-empty ng-valid-maxlength"
                        placeholder="Enter Plan Amount"
                      />
                    </div>
                    <div class="col-md-3">
                      <label>GST</label>
                      <input
                        type="number"
                        value={Gst}
                        onChange={(e) => setGst(e.target.value)}
                        class="form-control ng-pristine ng-untouched ng-valid ng-empty ng-valid-maxlength"
                        placeholder="Enter GST"
                      />
                    </div>
                    <div class="col-md-3">
                      <label>EV</label>
                      <input
                        type="number"
                        value={EV}
                        onChange={(e) => setEV(e.target.value)}
                        class="form-control ng-pristine ng-untouched ng-valid ng-empty ng-valid-maxlength"
                        placeholder="Enter EV"
                      />
                    </div>
                    {/* <div class="col-md-3">
                      <label>Roi</label>
                      <input
                        type="number"
                        value={Roi}
                        onChange={(e) => setRoi(e.target.value)}
                        class="form-control ng-pristine ng-untouched ng-valid ng-empty ng-valid-maxlength"
                        placeholder="Enter Roi "
                      />
                    </div>
                    <div class="col-md-3">
                      <label>RoiMonths</label>
                      <input
                        type="number"
                        value={RoiMonths}
                        onChange={(e) => setRoiMonths(e.target.value)}
                        class="form-control ng-pristine ng-untouched ng-valid ng-empty ng-valid-maxlength"
                        placeholder="Enter Roi Months"
                      />
                    </div> */}

                    <div class="col-md-3">
                      <input
                        type="button"
                        id="btnsearch"
                        onClick={() => {
                          AddnewPlan();
                        }}
                        class="btn btn-sm btn-primary"
                        value="Add Plan"
                      />
                    </div>
                  </div>
                  <div class="row">
                    {/* <h4>
                      <span>Total Income: {TotalAmount}</span>
                    </h4> */}

                    {isLoading ? (
                      <Spinner />
                    ) : (
                      <div className="col-md-12">
                        <Table data={currentPostleft} columns={my_team.cols} />

                        <Table_Buttons
                          indexOfFirstPage={indexOfFirstPage}
                          indexOfLastPost={indexOfLastPost}
                          setcurrentPage={setcurrentPage}
                          currentPage={currentPage}
                          totalData={leftreferralApi.length}
                          listPerpage={listPerpage}
                          handleRowsPerPageChange={setlistPerpage}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddmodifyPlansDetails;
